const BundleOrderLine = function (mainProductId, quantity, overwriteQuantity) {
  this.MainProductId = mainProductId;
  this.OverwriteQuantity = overwriteQuantity;
  this.Quantity = quantity;
  this.Items = [];
  this.pushItemToBundleOrderLine(mainProductId, 1);
};

BundleOrderLine.prototype = {
  pushItemToBundleOrderLine: function (id, quantity) {
    var item = this.Items.find(function (v) { return v.ProductIdentifier === id; });

    if (item !== undefined) {
      item.Quantity += quantity;
    }
    else {
      item = { ProductIdentifier: id, Quantity: quantity};
      this.Items.push(item);
    }

    this.Items.sort(function (v) { return v.ProductIdentifier; });

    id = "";
    for (var i = 0; i < this.Items.length; i++) {
      id += this.Items[i].ProductIdentifier + "_" + this.Items[i].Quantity + "_";
    }

    this.Id = id;

    return this;
  }
};

export default BundleOrderLine;



// WEBPACK FOOTER //
// ./EcomCore/Models/Order/BundleOrderLine.js